import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { KeyRound, ArrowRight } from "lucide-react";

export function CargusSetupBanner() {
  const { user } = useAuth();
  if (!user || user.has_cargus) return null;
  return (
    <div
      data-testid="cargus-setup-banner"
      className="mb-6 flex flex-col sm:flex-row sm:items-center gap-3 border border-[#FF9F0A]/40 bg-[#FF9F0A]/10 rounded-sm px-4 py-3"
    >
      <KeyRound size={18} className="text-[#FF9F0A] shrink-0" />
      <div className="flex-1">
        <div className="text-sm font-medium text-[#FF9F0A]">Adaugă-ți cheile Cargus ca să poți verifica</div>
        <div className="text-xs text-muted-foreground mt-0.5">
          Pune Subscription Key, utilizatorul și parola ta de Cargus în Setări. Verificările folosesc
          contul tău Cargus.
        </div>
      </div>
      <Link
        to="/setari"
        data-testid="cargus-setup-cta"
        className="inline-flex items-center justify-center gap-2 bg-primary text-primary-foreground rounded-sm px-4 py-2 text-sm font-medium hover:bg-white/90 transition-colors shrink-0"
      >
        Configurează Setări <ArrowRight size={15} />
      </Link>
    </div>
  );
}
